// extracted by mini-css-extract-plugin
module.exports = {"ClickButton":"PopForm_ClickButton__IDG_9","Header":"PopForm_Header__hfDQI"};